import {
  AccidentAtlasApiTile,
  AccidentAtlasChartConfig,
  AccidentAtlasChartType,
} from '../types/api'
import {
  AccidentAtlasChartRenderType,
  AccidentAtlasTileChart,
  AccidentAtlasTileDisplayKind,
} from '../types/tile'
import { prepareChartData } from './prepareChartData'

const CHART_TYPE_TO_RENDER_TYPE: Record<
  AccidentAtlasChartType,
  AccidentAtlasChartRenderType
> = {
  pie: 'PieChart',
  column: 'ColumnChart',
  line: 'LineChart',
}

export function apiChartTypeToRenderType(
  chartType: AccidentAtlasChartType
): AccidentAtlasChartRenderType {
  return CHART_TYPE_TO_RENDER_TYPE[chartType]
}

function toTileChart(
  config: AccidentAtlasChartConfig
): AccidentAtlasTileChart | null {
  const prepared = prepareChartData(config)
  if (!prepared) return null

  return {
    config: prepared,
    renderType: apiChartTypeToRenderType(prepared.chartType),
  }
}

export type DerivedTileCharts = {
  displayKind: AccidentAtlasTileDisplayKind
  charts: AccidentAtlasTileChart[]
}

export function deriveTileCharts(
  apiTile: AccidentAtlasApiTile
): DerivedTileCharts {
  if (!apiTile.chartConfig) {
    return { displayKind: 'text', charts: [] }
  }

  const chart = toTileChart(apiTile.chartConfig)

  if (!chart) {
    return { displayKind: 'text', charts: [] }
  }

  return { displayKind: 'chart', charts: [chart] }
}
